import Dropzone from './modules/dropzone'

Dropzone.autoDiscover = false;

$(() => {
  var listingForm = $('#listing-form-with-dropzone');
  var paramName = listingForm.data('form');
  var preloadImages = $('#images-from-server').data('images');

  if (listingForm.length) {
    new Dropzone('#listing-form-with-dropzone', {
      autoProcessQueue: false,
      uploadMultiple: true,
      maxFiles: 100,
      parallelUploads: 100,
      timeout: 900000,
      previewsContainer: '.dropzone-previews',
      paramName: paramName + '[pictures_attributes]',
      previewTemplate: document.querySelector('#dz-template').innerHTML,
      type: 'script',
      acceptedFiles: '.png,.jpg,.gif,.bmp,.jpeg,.webp',

      // The setting up of the dropzone
      init: function () {
        var myDropzone = this;

        if (preloadImages.length > 0) {
          // Preload images

          $.each(preloadImages, function (index, image) {
            var mockFile = { name: image.name, size: image.size };

            myDropzone.emit("addedfile", mockFile);

            var previewElement = $($(mockFile)[0].previewElement);
            previewElement.find('.dz-remove').attr('id', image.id);
            previewElement.attr('data-id', image.id);
            myDropzone.emit("thumbnail", mockFile, image.url);
          });
        }

        this.element.querySelector("input[type=submit]").addEventListener('click', function(e) {
          let submitButton = $(this);
          let required = listingForm.data('required');
          let proceedText = $(this.form).data('loader-text') || 'Processing...';
          let dropZonePreviews = $('.dropzone-previews .dz-preview');

          $(myDropzone.element).parsley().validate();

          let valid = $(myDropzone.element).parsley().isValid();
          if (!dropZonePreviews.length && required) {
            valid = false;
          }
          e.preventDefault();
          e.stopPropagation();
          if (valid) {
            submitButton.prop('disabled', true);
            submitButton.val(proceedText);

            // need for reordering
            if (dropZonePreviews.length) {
              dropZonePreviews.each(function (index, value) {
                var pictureId = $(value).data('id') || 'new-picture';

                $('<input>').attr({
                  type: 'hidden',
                  name: `${paramName}[pictures_position][][id]`,
                  value: pictureId,
                }).appendTo(listingForm);

                $('<input>').attr({
                  type: 'hidden',
                  name: `${paramName}[pictures_position][][position]`,
                  value: index + 1,
                }).appendTo(listingForm);
              });
            }

            if (myDropzone.getQueuedFiles().length > 0) {
              // Reorder query
              var currentQueue = [];
              $('#sortable .dz-preview').each(function () {
                let file = $(this).data('file');
                if (file) {
                  currentQueue.push($(this).data('file'));
                }
              });

              myDropzone.removeAllFiles();

              for (let i = 0; i < currentQueue.length; i++) {
                myDropzone.addFile(currentQueue[i]);
              }

              myDropzone.processQueue();

              $.busyLoadFull('show', { text: proceedText, fontawesome: 'animating-car-loader', background: 'rgba(0, 0, 0, 0.5)' });
            } else {
              listingForm.submit();
            }
          }
          return valid;
        });

        this.on('sendingmultiple', function (files, xhr, formData) {
          var imageField = $('.dz-pre-append');
          if (imageField.length > 0 ) {
            formData.append('business[logo]', $('.profile-logo').find('input').prop('files')[0]);
          }
        });

        this.on('successmultiple', function (files, response) {
          location.replace(response.redirect);
        });

        this.on('errormultiple', function () {
        });

        this.on('addedfile', function () {
          if (window.location.pathname.includes('listing_options')) {
            $('.dropzone-previews .dz-preview').first().css('background', 'white');
          } else {
            $('.dz-preview').each((i, el) => {
              el.dataset.primeText = $('.dropzone-previews').data('prime-text');
            });
          }
          $('.dz-message').css('border-color', '#bac2cd');
        });

        this.on('addedfile', function (file) {
          $('#sortable .dz-preview').last().data('file', file);
          if (!file.type.includes('image')) {
            this.removeFile(file);
          }
        });

        // this.on("totaluploadprogress", function(progress) {
        //   if (progress > 0.0) {
        //     if ($('.busy-load-text').text().includes('%')) {
        //       $('.busy-load-text').text($('.busy-load-text').text().replace(/\d+/g, parseInt(progress)))
        //     } else {
        //       $('.busy-load-text').text(`${$('.busy-load-text').text()}.. ${parseInt(progress)}%`)
        //     }
        //   }
        // });

        this.on('removedfile', function (file) {
          if (!$('.dropzone-previews .dz-preview ').length) {
            $('.dz-message').css('border-color', '#f81300');
          }
          var removeId = $(file.previewElement).find('.dz-remove').attr('id');
          if (removeId) {
            $('<input>').attr({
              type: 'hidden',
              name: `${paramName}[pictures_attributes_destroy][][id]`,
              value: removeId,
            }).appendTo(listingForm);

            $('<input>').attr({
              type: 'hidden',
              name: `${paramName}[pictures_attributes_destroy][][_destroy]`,
              value: '1',
            }).appendTo(listingForm);
          }
        });
      },

      error: function ({... xhr}, {... error}) {
        if (xhr.xhr) {
          console.log(xhr.xhr.status);
          console.log(error.email[0]);

          if (xhr.xhr.status === 422) {
            $('.busy-load-text').text(`Email ${error.email[0]}`);
          }
        }

        setTimeout(function () {
          $.busyLoadFull('hide');
          window.location.reload();
        }, 5000);
      },
    });
  }
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/image_upload.js